export const FETCH_USER = 'FETCH_USER';
export const FETCH_ISSUER = 'FETCH_ISSUER';
export const UPDATE_ISSUER = 'UPDATE_ISSUER';
export const FETCH_BADGECLASS = 'FETCH_BADGECLASS';
export const CREATE_BADGECLASS = 'CREATE_BADGECLASS';
export const UPDATE_BADGECLASS = 'UPDATE_BADGECLASS';
export const FETCH_BADGECLASSES = 'FETCH_BADGECLASSES';
export const FETCH_ASSERTIONS = 'FETCH_ASSERTIONS';
export const FETCH_ASSERTION = 'FETCH_ASSERTION';
export const CREATE_ASSERTION = 'CREATE_ASSERTION';
export const IMPORT_ASSERTIONS = 'IMPORT_ASSERTIONS';
export const UPDATE_ASSERTION = 'UPDATE_ASSERTION';



// WEBPACK FOOTER //
// ./src/actions/types.js